import React from 'react';
import { partial, times } from 'lodash';
import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ImagePicker from '@dyl/components/ImagePicker';

const useStyles = makeStyles(theme => ({
    itemsContainer: {
        maxWidth: theme.breakpoints.values.md,
        marginBottom: theme.spacing(3),
    },
}));

export default function MultiSelectEditor({ index }) {
    const classes = useStyles();
    const useField = partial(useTaskField, 'items', index);

    const [{ length }] = useField('answers');

    return (
        <Grid container spacing={2} className={classes.itemsContainer}>
            {times(length, answerIndex => (
                <Item
                    key={answerIndex}
                    itemIndex={index}
                    index={answerIndex}
                />
            ))}
        </Grid>
    );
}

function Item({ itemIndex, index }) {
    const useField = partial(useTaskField, 'items', itemIndex, 'answers', index);

    const [imageId, setImageId, imageError] = useField('image_id');

    return (
        <Grid item xs={12} sm={6} md={4}>
            <ImagePicker
                id={`${index}`}
                label={`Prompt image ${index + 1}`}
                value={imageId ?? ''}
                onChange={id => setImageId(id)}
                helperText={imageError || 'Must be 800x500px'}
                error={!!imageError}
                fullWidth
            />
        </Grid>
    );
}